import React from "react";

import DownloadIcon from "@uui/Download01";

import HeaderButton from "@app/analytics/components/reports/HeaderButton";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import Menu from "@rui/Menu";

import { DownloadLink, DownloadMenuItem } from "./styles";
import type { DownloadProps } from "./types";

const DownloadButtonAndPopover = ({ disabled, downloads }: DownloadProps) => {
  const { anchorEl, open, onClose, onClick } = useAnchorElement();

  return (
    <>
      <HeaderButton
        className="meeting-report__header__downloads"
        startIcon={<DownloadIcon />}
        onClick={onClick}
        disabled={disabled}
      >
        Download
      </HeaderButton>
      <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
        {Object.values(downloads).map(
          ({ href, download, onClick, label, show }) => {
            if (!show) return null;
            return (
              <DownloadMenuItem key={label}>
                <DownloadLink
                  href={href}
                  download={download}
                  onClick={() => {
                    onClick();
                    onClose();
                  }}
                >
                  {label}
                </DownloadLink>
              </DownloadMenuItem>
            );
          }
        )}
      </Menu>
    </>
  );
};

export default DownloadButtonAndPopover;
